import React, { useEffect } from 'react';
import { useAuthDispatch } from 'context';

export const LogoutScreen = () => {
  const authDispatch = useAuthDispatch();
  useEffect(() => {
    authDispatch({ type: 'LOGOUT' });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return <></>;
};
